export default Object.freeze({
  // UNAUTHORIZED_
  AUTO_LOGOUT: '자동으로 로그아웃 되었습니다.',
  REASON: '로그인 후 일정시간 동안 사이트를 이용하지 않아 <br>고객님의 정보보호를 위하여 자동으로 로그아웃 되었습니다.',
  REUSE_PLEASE: '다시 이용하시려면 아래 로그인 버튼을 눌러 주십시오.',
  LOGIN: '로그인',
});